import * as THREE from "three";
import Experience from "./Experience";
import data from "../../static/data/data";

import fragment from "@shaders/mesh/fragment.glsl";
import vertex from "@shaders/mesh/vertex.glsl";
import gsap from "gsap";

export default class Mesh {
	constructor(x, id) {
		this.experience = new Experience();

		const geometry = new THREE.PlaneGeometry(4, 2.5, 15, 15);
		const material = this.LoadTexture(id);

		this.mesh = new THREE.Mesh(geometry, material);
		this.mesh.position.set(x, 0, 0);
		this.mesh.material.opacity = 0;

		this.animateIn(id);
	}

LoadTexture(id) {
  const loader = new THREE.TextureLoader();
  const texture = loader.load(data[id].image, (tex) => {
    this.mesh.material.uniforms.uTextureSize.value.set(
      tex.image.naturalWidth,
      tex.image.naturalHeight
    );
  });

  return new THREE.ShaderMaterial({
    uniforms: {
      diffuse: { value: texture },
      uTextureSize: { value: new THREE.Vector2(1, 1) },
      uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
      uQuadSize: { value: new THREE.Vector2(4, 2.5) },
      uScrollVelocity: { value: this.experience.scroll.scrollY },
      uTime: { value: 0 },
      uOpacity: { value: 0 },
    },
    vertexShader: vertex,
    fragmentShader: fragment,
    transparent: true,
  });
}

update() {
  this.mesh.material.uniforms.uScrollVelocity.value = this.experience.scroll.smoothedVelocity;
  this.mesh.material.uniforms.uTime.value = this.experience.time.elapsed;

  // Maintenir la bonne taille si le scale change
  this.mesh.material.uniforms.uQuadSize.value.set(
    this.mesh.scale.x * 4,
    this.mesh.scale.y * 2.5
  );
}

onResize() {
  this.mesh.material.uniforms.uResolution.value.set(window.innerWidth, window.innerHeight);
}

async animateIn(id) {
	gsap.from(this.mesh.position, {
		z: -5,
		duration: 1,
		ease: "power4.out",
		delay: 2.5 + id * 0.1,
	});
	gsap.to(this.mesh.material.uniforms.uOpacity, {
		value: 1,
		duration: 1,
		ease: "power4.out",
		delay: 2.5 + id * 0.1,
	});
}

}
